import useCommonStore from "../../store/CommonStore";

export function usePagination() {
  const { pageIndex, setPageIndex, pageSize, setPageSize } = useCommonStore();

  const getPaginationInfo = (responseData: any) => ({
    pageIndex,
    setPageIndex,
    pageSize,
    setPageSize,
    total: responseData?.total || 0,
    totalPages: responseData?.total_pages || 1,
    hasNext: responseData?.has_next || false,
    hasPrev: responseData?.has_prev || false,
  });

  return {
    pageIndex,
    setPageIndex,
    pageSize,
    setPageSize,
    getPaginationInfo,
  };
}
